var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Radio } from '@robinpowered/ui-kit';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useEventDetailContext } from '../context/EventDetailContextProvider';
import { useEventApi } from '../../hooks/useEvent/useEventApi';
import { useConfig } from '../../context/ConfigContext';
import { InternalModal } from '../../components/InternalModal';
import { useTranslation } from 'react-i18next';
import { EventSeriesOption, } from '../../hooks/useEvent/useEventTypes';
import { rrulestr } from 'rrule';
import moment from 'moment';
import { EventDetailsSuccessActions } from '../../..';
import { resolveAsSpaceCancelOptions } from '../../utils/asSpaceCancel';
export var isLastInstanceInSeries = function (seriesMaster, instanceEndTime) {
    var recurrence = getEventRRuleSet(seriesMaster);
    return !(recurrence === null || recurrence === void 0 ? void 0 : recurrence.after(instanceEndTime.toDate()));
};
export var isFirstInstanceInSeries = function (seriesMaster, instanceStartTime) {
    var recurrence = getEventRRuleSet(seriesMaster);
    return !(recurrence === null || recurrence === void 0 ? void 0 : recurrence.before(instanceStartTime.toDate()));
};
export var getEventRRuleSet = function (seriesMaster) {
    var _a;
    if (!Array.isArray(seriesMaster === null || seriesMaster === void 0 ? void 0 : seriesMaster.recurrence)) {
        return null;
    }
    return rrulestr(__spreadArray([
        // @FIXME: Currently when using `forceset: true` `rrulestr` doesn't
        // add `dtstart` properties from options. To address that we manually add the
        // DTSTART property, but that's not ideal.
        "DTSTART:".concat(moment((_a = seriesMaster === null || seriesMaster === void 0 ? void 0 : seriesMaster.start) === null || _a === void 0 ? void 0 : _a.date_time)
            .utc()
            .format('YYYYMMDDTHHmmss[Z]'))
    ], __read(seriesMaster.recurrence), false).join('\n'), {
        forceset: true,
        dtstart: moment(seriesMaster.start.date_time).toDate(),
    });
};
export var DeleteModal = function (_a) {
    var eventId = _a.eventId, eventStartTime = _a.eventStartTime, seriesId = _a.seriesId, removeSpace = _a.removeSpace, spaceId = _a.spaceId, remoteType = _a.remoteType, onDelete = _a.onDelete, onClose = _a.onClose;
    var t = useTranslation('modal').t;
    var _b = useConfig(), environmentUrls = _b.environmentUrls, userContext = _b.userContext, tenantId = _b.tenantId, accessToken = _b.accessToken;
    var apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var currentOrg = userContext.currentOrg;
    var _c = useEventDetailContext(), isRecurringEvent = _c.isRecurringEvent, onError = _c.onError, onSuccess = _c.onSuccess;
    var _d = __read(useState(false), 2), deletingEvent = _d[0], setDeletingEvent = _d[1];
    var _e = __read(useState(null), 2), eventSeries = _e[0], setEventSeries = _e[1];
    var _f = __read(useState(EventSeriesOption.THIS_EVENT), 2), deleteEventSeriesOption = _f[0], setDeleteEventSeriesOption = _f[1];
    var _g = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }), fetchEventSeries = _g.fetchEventSeries, deleteEvent = _g.deleteEvent, cancelEventAsSpace = _g.cancelEventAsSpace;
    useEffect(function () {
        if (seriesId) {
            fetchEventSeries(seriesId).then(function (eventSeries) {
                if (eventSeries) {
                    setEventSeries(eventSeries);
                }
            });
        }
    }, [seriesId, fetchEventSeries]);
    var handleCancelAsSpace = useCallback(function (spaceId, eventSeriesOption) { return __awaiter(void 0, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!eventId) {
                        return [2 /*return*/];
                    }
                    setDeletingEvent(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, cancelEventAsSpace(spaceId, eventId, eventSeriesOption)];
                case 2:
                    success = _a.sent();
                    if (success) {
                        onDelete();
                        onSuccess(EventDetailsSuccessActions.DELETE_EVENT);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setDeletingEvent(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [cancelEventAsSpace, eventId, onDelete, onSuccess]);
    var isFirstInstance = useMemo(function () {
        return eventSeries && eventStartTime
            ? isFirstInstanceInSeries(eventSeries, eventStartTime)
            : false;
    }, [eventSeries, eventStartTime]);
    var handleDeleteEvent = useCallback(function (eventId, eventSeriesOption) { return __awaiter(void 0, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setDeletingEvent(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, deleteEvent(eventId, eventSeriesOption)];
                case 2:
                    success = _a.sent();
                    if (success) {
                        onDelete();
                        onSuccess(EventDetailsSuccessActions.DELETE_EVENT);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setDeletingEvent(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [deleteEvent, onDelete, onSuccess]);
    var deleteEventSeriesOptions = useMemo(function () {
        return [
            {
                value: EventSeriesOption.THIS_EVENT,
                label: t('delete_modal.recurring_event.this_event'),
            },
            {
                value: EventSeriesOption.ALL_EVENTS,
                label: t('delete_modal.recurring_event.all_events'),
            },
            isFirstInstance
                ? undefined
                : {
                    value: EventSeriesOption.THIS_AND_FOLLOWING_EVENTS,
                    label: t('delete_modal.recurring_event.this_and_following_events'),
                },
        ].filter(Boolean);
    }, [t, isFirstInstance]);
    if (removeSpace) {
        if (spaceId === undefined) {
            onError(new Error(t('errors.space_id_required')));
            onClose();
            return null;
        }
        if (isRecurringEvent) {
            /* Providers differ in which series operations a space may perform
               (e.g. Google has no this-and-following as the space) */
            var allowedOptions_1 = resolveAsSpaceCancelOptions({
                isRecurring: true,
                remoteType: remoteType,
            });
            var options = deleteEventSeriesOptions.filter(function (option) {
                return allowedOptions_1.includes(option.value);
            });
            return (_jsx(InternalModal, { onCancel: onClose, onConfirm: function () {
                    return handleCancelAsSpace(spaceId, deleteEventSeriesOption);
                }, title: t('cancel_as_space_modal.recurring.title'), confirming: deletingEvent, byline: _jsxs(_Fragment, { children: [t('cancel_as_space_modal.recurring.byline'), _jsx(Radio.Group, { style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 8,
                                marginTop: 12,
                            }, onChange: function (e) { return setDeleteEventSeriesOption(e.target.value); }, value: deleteEventSeriesOption, options: options })] }), confirmText: t('cancel_as_space_modal.recurring.confirm'), cancelText: t('cancel_as_space_modal.recurring.cancel') }));
        }
        return (_jsx(InternalModal, { onCancel: onClose, onConfirm: function () {
                return handleCancelAsSpace(spaceId, EventSeriesOption.THIS_EVENT);
            }, title: t('cancel_as_space_modal.single.title'), confirming: deletingEvent, byline: t('cancel_as_space_modal.single.byline'), confirmText: t('cancel_as_space_modal.single.confirm'), cancelText: t('cancel_as_space_modal.single.cancel') }));
    }
    if (isRecurringEvent) {
        var content = (_jsx(Radio.Group, { style: { display: 'flex', flexDirection: 'column', gap: 8 }, onChange: function (e) { return setDeleteEventSeriesOption(e.target.value); }, value: deleteEventSeriesOption, options: deleteEventSeriesOptions }));
        /* Recurring event deletion */
        return (_jsx(InternalModal, { onCancel: onClose, onConfirm: function () { return handleDeleteEvent(eventId, deleteEventSeriesOption); }, title: t('delete_modal.recurring_event.title'), confirming: deletingEvent, byline: content, confirmText: t('delete_modal.confirm'), cancelText: t('delete_modal.cancel') }));
    }
    /* Single event deletion */
    return (_jsx(InternalModal, { onCancel: onClose, onConfirm: function () { return handleDeleteEvent(eventId, EventSeriesOption.THIS_EVENT); }, title: t('delete_modal.heading'), confirming: deletingEvent, byline: t('delete_modal.byline'), confirmText: t('delete_modal.confirm'), cancelText: t('delete_modal.cancel') }));
};
